import { TFunction } from 'i18next';

import { TabItem } from 'components/general/TabStrip';

export enum TaskTabsEnum {
  Details = 'details',
  Steps = 'steps',
  TimeAndNotes = 'timeAndNotes',
  Activity = 'activity',
}

type BuildTaskTabsParams = {
  t: TFunction;
};

export function buildTaskTabs({ t }: BuildTaskTabsParams): TabItem[] {
  return [
    {
      label: t('web.admin.workOrder.preventiveMaintenance.task.tabs.details'),
      value: TaskTabsEnum.Details,
    },
    {
      label: t('web.admin.workOrder.preventiveMaintenance.task.tabs.steps'),
      value: TaskTabsEnum.Steps,
    },
    {
      label: t(
        'web.admin.workOrder.preventiveMaintenance.task.tabs.hoursAndNotes'
      ),
      value: TaskTabsEnum.TimeAndNotes,
    },
    {
      label: t('web.admin.workOrder.preventiveMaintenance.task.tabs.activity'),
      value: TaskTabsEnum.Activity,
    },
  ];
}
